"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBaseQueryWithReAuthMutex = exports.apiReAuthMutex = exports.createFetchBaseQueryWithToken = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("@reduxjs/toolkit/dist/query/react");

var _asyncMutex = require("async-mutex");

var _globalMessage = require("../../GlobalMessage/store/globalMessage.actions");

var _waitForMutexLocked = require("./waitForMutexLocked");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var createFetchBaseQueryWithToken = function createFetchBaseQueryWithToken() {
  var OptionsRef = {
    baseUrl: undefined,
    getToken: undefined,
    isSet: false
  };

  var setApiOptions = function setApiOptions(_ref) {
    var baseUrl = _ref.baseUrl,
        getToken = _ref.getToken;

    if (OptionsRef.isSet) {
      if (window.APP_CONFIG.environment === 'development') {
        throw new Error("[@alycecom/services]: You shouldn't set coreApiOptions twice!");
      }

      return;
    }

    OptionsRef.baseUrl = baseUrl;
    OptionsRef.getToken = getToken;
    OptionsRef.isSet = true;
  };

  return {
    setApiOptions: setApiOptions,
    baseQuery: function baseQuery() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _prepareHeaders = _ref2.prepareHeaders,
          fetchBaseQueryArgs = (0, _objectWithoutProperties2["default"])(_ref2, ["prepareHeaders"]);

      return function (args, api, extraOptions) {
        return (0, _react.fetchBaseQuery)(_objectSpread({
          prepareHeaders: function prepareHeaders(headers, prepareHeadersApi) {
            var _prepareHeaders2;

            if (OptionsRef.getToken) {
              headers.set('Authorization', "Bearer ".concat(OptionsRef.getToken()));
            }

            return (_prepareHeaders2 = _prepareHeaders === null || _prepareHeaders === void 0 ? void 0 : _prepareHeaders(headers, prepareHeadersApi)) !== null && _prepareHeaders2 !== void 0 ? _prepareHeaders2 : headers;
          },
          credentials: 'include',
          baseUrl: OptionsRef.baseUrl
        }, fetchBaseQueryArgs))(args, api, extraOptions);
      };
    }
  };
};

exports.createFetchBaseQueryWithToken = createFetchBaseQueryWithToken;
var apiReAuthMutex = new _asyncMutex.Mutex();
exports.apiReAuthMutex = apiReAuthMutex;

var fetchBaseQueryWithReAuthMutex = function fetchBaseQueryWithReAuthMutex(fetchBaseQueryFn) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(args, api, extraOptions) {
      var result;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apiReAuthMutex.waitForUnlock();

            case 2:
              _context.next = 4;
              return fetchBaseQueryFn(args, api, extraOptions);

            case 4:
              result = _context.sent;

              if (!(result.error && result.error.status === 401)) {
                _context.next = 15;
                break;
              }

              if (apiReAuthMutex.isLocked()) {
                _context.next = 10;
                break;
              }

              api.dispatch((0, _globalMessage.handleServerError)(result.error));
              _context.next = 10;
              return (0, _waitForMutexLocked.waitForMutexLocked)(apiReAuthMutex);

            case 10:
              _context.next = 12;
              return apiReAuthMutex.waitForUnlock();

            case 12:
              _context.next = 14;
              return fetchBaseQueryFn(args, api, extraOptions);

            case 14:
              result = _context.sent;

            case 15:
              return _context.abrupt("return", result);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.fetchBaseQueryWithReAuthMutex = fetchBaseQueryWithReAuthMutex;